export default class CategoriesDataTransformer {
  constructor (categories) {
    this.categories = categories
  }

  get transformedData () {
    return this.categories.map((category) => {
      return {
        id: category.id,
        name: category.attributes.name,
        path: 'booking-service-category-show',
        params: { id: category.attributes['slug-url'] },
        gaTrackingClass: 'ga-olr-bs-link'
      }
    })
  }
}
